import DatePicker from "components/app/function/DatePicker";
import InputSelectAutoSuggest from "components/app/function/InputSelectAutoSuggest";

import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { ChevronDown, ImageUp, Loader, Minus, Plus, UserRoundPlus, UserRoundX, X } from "lucide-react";
import Religion from "../dummyStaff";
import { useEffect, useState } from "react";
import StaffAction from "../StaffAction";
import DailogAdddLineManagerStaff from "./DailogAdddLineManagerStaff";
import appStore from "store/appStore";

import Shift from "../Shift";
import TextInput from "components/app/function/TextInput";
import NumberInput from "components/app/function/NumberInput";

import SelectGroupRadioOptionSingle from "components/app/function/SelectOneRadioOption";
import { RequestApi, RouteApi, StatusMsg } from "utils";

import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { useLocation } from "react-router-dom";
import { ShimmerDialogEditProduct } from "components/app/shrimmer/Shrimmer";
import ImageUrl from "components/app/image-url/ImageUrl";

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "components/ui/collapsible";

import { cn } from "lib/utils";

import { noneProfile, profileVerified } from "assets";

import DatePickerInput from "components/app/function/DatePickerInput";

import { Button } from "components/ui/button";

import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import DailogAddUserAccountId from "./DailogAddUserAccountId";
import useUrlString from "../useUrlString";

interface DialogProps {
  // onUploadSuccess: ({ res, name }: { res: any; name: string }) => void;

  onSubmitCreateAndUpdateStaff: any;
  setUserShopShiftGroup: any;
  userShopShiftGroup: any;
  department: any;
  isCreateStaff: boolean;
  isDialogOpenAddAndEditStaff: boolean;
  setisDialogOpenAddAndEditStaff: (value: boolean) => void;
  setIsDailogUploadStaff: (value: boolean) => void;
  setIsCreateStaff: (value: boolean) => void;
  setEmergencyContact: any;
  setJobInfo: any;
  setPersonalInfo: any;
  emergencyContact: any;
  personalInfo: any;
  jobInfo: any;
  setReligion: any;
  setBankAccount: any;
  setNationality: any;
  setProbationDate: any;
  setJoinedDate: any;
  setDob: any;
  paymenthod: any;
  setDepartmentName: any;
  setShiftGroupId: any;
  editEmloyeeId: any;
  setEditEmloyeeId: any;
  joinedDate: any;
  setPermissions: any;
  permissions: any;
  onUploadSuccess: ({ res, name }: { res: any; name: string }) => void;
  loadingSubmitCreateUpdateStaff: any;
  clearData: any;
  probationDate: any;
  loadingFetchDataShopEmployeeDetail: any;
  ShopEmployeeDetail: any;
  setShopEmployeeDetail: any;
  religion: any;
  nationality: any;
  dob: any;
  shiftGroupId: any;
  selectedProductIds: any;
  departmentName: any;
  setAllsetDepartment: any;
  setShopEmployee: any;
  editItemCategories: any;
  setPaymethod: any;
  lastWorkingDate: any;
  setLastWorkingDate: any;
  setOpenPopoverIndex: any;
}
export default function PageEditAndAddStaff({
  setIsDailogUploadStaff,
  editItemCategories,
  setOpenPopoverIndex,
  loadingFetchDataShopEmployeeDetail,
  ShopEmployeeDetail,
  setShopEmployeeDetail,
  department,
  isDialogOpenAddAndEditStaff,
  setisDialogOpenAddAndEditStaff,
  isCreateStaff,
  setIsCreateStaff,
  userShopShiftGroup,
  setUserShopShiftGroup,
  onSubmitCreateAndUpdateStaff,
  setEmergencyContact,
  setJobInfo,
  setPersonalInfo,
  emergencyContact,
  personalInfo,
  jobInfo,
  setReligion,
  setBankAccount,
  setNationality,
  paymenthod,
  setPaymethod,
  setProbationDate,
  setJoinedDate,
  joinedDate,
  setDob,
  setDepartmentName,
  setShiftGroupId,
  editEmloyeeId,
  setEditEmloyeeId,
  onUploadSuccess,
  loadingSubmitCreateUpdateStaff,
  clearData,
  probationDate,
  religion,
  nationality,
  dob,
  shiftGroupId,
  setAllsetDepartment,
  setShopEmployee,
  lastWorkingDate,
  setLastWorkingDate,
  permissions,
  setPermissions,
}: DialogProps) {
  const { RelligoionData, NationalityData, Paymenthod, Permissions } = Religion();
  const { showDialogConfirm } = appStore();
  const { departmentActive, setDepartmentActive, loadingSubmitDelete } = StaffAction();
  const { token } = useAppSelector((state) => state.auth);
  const [searchTextInput, setSearchTextInput] = useState<string>("");

  const [isDailogAddLineManager, setisDailogAddLineManager] = useState<boolean>(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const { hanleClickRemoveURl } = useUrlString();
  const submitDeleteShopEmployee = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_ids: [ShopEmployeeDetail.id],
        shop_id: shopId,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses) {
            hanleClickRemoveURl("staff_id");

            setAllsetDepartment(responses?.user_shop_departments);
            onUploadSuccess({
              res: responses.user_shop_employee,
              name: "delete",
            });
            setisDialogOpenAddAndEditStaff(false);
            setOpenPopoverIndex(null);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [staffName, setStaffName] = useState<string>("");
  const [salary, setSalary] = useState<string>("");
  const [dobMessage, setDobMessage] = useState<string>("");
  const [joinedDateMessage, setjoinedDateMessage] = useState<string>("");
  const [probationDateMessage, setprobationDateMessage] = useState<string>("");
  const [departmentMessage, setDepartmentMessage] = useState<string>("");
  // --------------message--------------
  const [departmentSelect, setDepartmentSelect] = useState<boolean>(false);

  useEffect(() => {
    if (personalInfo.local_name !== "") {
      setStaffName("");
    }
    if (jobInfo.basic_salary !== "") {
      setSalary("");
    }
    if (!dob) {
      setDobMessage("");
    }
    if (!joinedDate) {
      setjoinedDateMessage("");
    }
    if (!probationDate) {
      setprobationDateMessage("");
    }
    if (!departmentSelect === false) {
      setDepartmentMessage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ---------------shop employee detail----------
  // console.log("ShopEmployeeDetail", ShopEmployeeDetail);
  const handlePermissionChange = (index: number, newValue: string) => {
    const updated = [...ShopEmployeeDetail.permissions];
    updated[index].permission = newValue;
    setPermissions(updated);
    // setShopEmployeeDetail((prev: any) => ({
    //   ...prev,
    //   permissions: updated,
    // }));
  };
  console.log(ShopEmployeeDetail, "ShopEmployeeDetail");

  useEffect(() => {
    if (ShopEmployeeDetail) {
      setDepartmentName(ShopEmployeeDetail.department);
      setDepartmentActive(ShopEmployeeDetail.department);
      setPersonalInfo({
        local_name: ShopEmployeeDetail.local_name,
        english_name: ShopEmployeeDetail.english_name,
        gender: ShopEmployeeDetail.gender,
        marital_status: ShopEmployeeDetail.marital_status,
        id_card_no: ShopEmployeeDetail.id_card_no,
        passport_no: ShopEmployeeDetail.passport_no,
        phone_no: ShopEmployeeDetail.phone_no,
        phone_no_2: ShopEmployeeDetail.phone_no_2,
        email: ShopEmployeeDetail.email,
        address: ShopEmployeeDetail.address,
        permanent_address: ShopEmployeeDetail.permanent_address,
        employee_telegram_id: ShopEmployeeDetail.employee_telegram_id,
        employee_account_id: ShopEmployeeDetail.employee_account_id,
        bank_account_no: ShopEmployeeDetail.bank_account_no,
        // permission: ShopEmployeeDetail.permission,
      });
      setNationality(ShopEmployeeDetail.nationality);
      setPaymethod(ShopEmployeeDetail.pay_method);
      setBankAccount(ShopEmployeeDetail.bank_account_no);
      setReligion(ShopEmployeeDetail.religion);
      setDob(ShopEmployeeDetail.date_of_birth);

      setJobInfo({
        card_no: ShopEmployeeDetail.card_no,
        attendance_card_no: ShopEmployeeDetail.attendance_card_no,
        nssf_no: ShopEmployeeDetail.nssf_no,
        position: ShopEmployeeDetail.position,
        basic_salary: ShopEmployeeDetail?.basic_salary,
        end_probation_remark: ShopEmployeeDetail.end_probation_remark,
        food_allownace: ShopEmployeeDetail.food_allownace,
        phone_allownace: ShopEmployeeDetail.phone_allownace,
        housing_allownace: ShopEmployeeDetail.housing_allownace,
        last_working_date: ShopEmployeeDetail.last_working_date,
      });

      setEmergencyContact({
        emergency_contact_name: ShopEmployeeDetail.emergency_contact_name,
        emergency_contact_phone_no: ShopEmployeeDetail.emergency_contact_phone_no,
        emergency_contact_email: ShopEmployeeDetail.emergency_contact_email,
        family_dependent: ShopEmployeeDetail.family_dependent,
      });
      setJoinedDate(ShopEmployeeDetail.joined_date);
      setProbationDate(ShopEmployeeDetail.probation_date);
      setLastWorkingDate(ShopEmployeeDetail.last_working_date);
      setShiftGroupId(ShopEmployeeDetail.shift_group_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ShopEmployeeDetail, shopId]);

  //---------------delete shop manager -----------
  const [loadingSubmitDeleteShopEmployeeManager, setLoadingSubmitDeleteShopEmployeeManager] = useState<boolean>(false);
  const [idRecommendedDelete, setIdRecommendedDelete] = useState(null);

  const submitDeleteShopEmployeeManager = async (id: any) => {
    setLoadingSubmitDeleteShopEmployeeManager(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopEmployeeManager;
      url += `token=${token}`;
      const pyaload = {
        shop_id: shopId,
        employee_id: editEmloyeeId,
        manager_employee_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        getShopEmployeeManager();
        // getShopEmployeeDetail()
        setShopEmployeeDetail((prevItemGroups: any) => {
          return {
            ...prevItemGroups,
            managers: (prevItemGroups.managers || []).filter((item: any) => !id.includes(item.employee_id)),
          };
        });
        setLoadingSubmitDeleteShopEmployeeManager(false);
      }
    } catch (error) {
      setLoadingSubmitDeleteShopEmployeeManager(false);

      AppLog.show({
        message: `[submitDeleteShopEmployeeManager]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  // --------------------------
  const [itemEmployeeManager, setItemEmployeeManager] = useState<any>([]);
  const getShopEmployeeManager = async () => {
    try {
      const url = `${RouteApi.getShopEmployeeManager}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        employee_id: editEmloyeeId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setItemEmployeeManager(response.user_shop_employees);
      } else {
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      AppLog.show({
        message: `[getShopEmployeeManager]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [itemShopPermissionSearchUser, setItemShopPermissionSearchUser] = useState<any>([]);
  const [loadingGetUser, setLoadingGetUser] = useState<boolean>(false);
  const [isOpenDialogAddUser, setIsOpenDialogAddUser] = useState(false);
  const getShopPermissionSearchUser = async (setSearchTextUser: any) => {
    setLoadingGetUser(true);
    try {
      const url = `${RouteApi.getShopPermissionSearchUser}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: setSearchTextUser,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingGetUser(false);
        setItemShopPermissionSearchUser(response.users);
      } else {
        setLoadingGetUser(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setLoadingGetUser(false);

      AppLog.show({
        message: `[getShopEmployeeManager]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    getShopEmployeeManager();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEmloyeeId, searchTextInput]);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpens, setIsOpens] = useState(true);
  const [isOpen3, setIsOpen3] = useState(true);
  const [isOpen4, setIsOpen4] = useState(true);
  console.log(ShopEmployeeDetail, "ShopEmployeeDetail2");

  return (
    <>
      <div>
        <div className="custom-dialog-class flex flex-col justify-between max-w-[1000px] h-[calc(100vh-80px)]">
          <div>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col gap-2 absolute left-3 top-[12px]">
                <div className="text-lg font-bold">{!editEmloyeeId ? "Create New Staff Profile" : "Update Staff Profile"}</div>
                <div>Input Staff Name, English Name and Other Information, click "Save" when you finished.</div>
              </div>
              {!editEmloyeeId && (
                <label
                  onClick={() => {
                    setIsDailogUploadStaff(true);
                    setisDialogOpenAddAndEditStaff(false);
                    setOpenPopoverIndex(null);
                  }}
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all absolute right-3 top-[12px]  duration-300 me-[50px] font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <ImageUp />
                </label>
              )}
            </div>
            <div
              className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 border border-gray-300 "
              onClick={() => {
                setIsCreateStaff(false);
                setisDialogOpenAddAndEditStaff(false);
                setEditEmloyeeId(null);
                clearData();
                setOpenPopoverIndex(null);
              }}
            >
              <X />
            </div>
          </div>
          {loadingFetchDataShopEmployeeDetail ? (
            <>
              <div className="h-[80vh] mt-8 overflow-hidden">
                <ShimmerDialogEditProduct />
              </div>
            </>
          ) : (
            <ScrollArea className="mt-8 gap-3 pr-[10px] pb-[50px] ">
              <div className="space-y-6 px-1 py-1  ">
                <Collapsible open={isOpen} onOpenChange={setIsOpen} className="w-full outline-none focus:border-none ">
                  <div className="flex items-center justify-between">
                    <h4 className="text-xl font-semibold text-blue-600  ">Personal Information</h4>
                    <CollapsibleTrigger asChild>
                      <Button variant="ghost" size="sm">
                        <ChevronDown className={cn("h-4 w-4 transition-transform duration-300", !isOpen && "rotate-180")} />
                        <span className="sr-only">Toggle</span>
                      </Button>
                    </CollapsibleTrigger>
                  </div>

                  <CollapsibleContent className="space-y-2">
                    <div className="space-y-6 px-2 py-4 duration-900">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">
                            Staff Name <span className="text-red-600">*</span>
                          </label>
                          <TextInput
                            className="focus:border-none"
                            value={personalInfo.local_name}
                            onChange={(event) => {
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                local_name: event.target.value,
                              }));
                            }}
                          />
                          {personalInfo.local_name === "" ? <label className="text-red-600 text-sm">{staffName}</label> : ""}
                        </div>

                        <div>
                          <label className="block mb-1 text-md font-medium">English Name</label>
                          <TextInput
                            value={personalInfo.english_name}
                            onChange={(event) => {
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                english_name: event.target.value,
                              }));
                            }}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 ">
                        {/* gender */}
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Gender</label>
                          <SelectGroupRadioOptionSingle
                            datas={["Male", "Female"]}
                            value={personalInfo.gender}
                            valueChange={(value) => {
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                gender: value,
                              }));
                            }}
                          />
                        </div>
                        {/* Date */}
                        <div className="">
                          <label className="block mb-1 text-md font-medium">
                            Date of Birth <span className="text-red-600">*</span>
                          </label>
                          <div className="">
                            <DatePicker
                              className="py-4 h-[45px] border border-gray-300 "
                              onChange={(value) => {
                                setDob(value);
                              }}
                              value={dob}
                            />
                            {/* <DatePickerWithMonthYear value={selectedDate} onChange={setSelectedDate} classname="w-[220px]" /> */}
                          </div>
                          {!dob ? <label className="text-red-600 text-sm">{dobMessage}</label> : ""}
                        </div>
                        {/* married */}
                        <div className="col-span-2">
                          <label className="block mb-1 text-md font-medium">Marital Status</label>

                          <SelectGroupRadioOptionSingle
                            datas={["Single", "Married", "Divorced", "Remarried"]}
                            value={personalInfo.marital_status}
                            valueChange={(value: string) => {
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                marital_status: value,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      {/* ---------------line 3----------------- */}
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">Nationality</label>

                          <InputSelectAutoSuggest
                            value={nationality}
                            onChange={(answer) => {
                              setNationality(answer.value);
                            }}
                            datas={NationalityData}
                          />
                        </div>

                        <div>
                          <label className="block mb-1 text-md font-medium">Religion</label>

                          <InputSelectAutoSuggest
                            value={religion}
                            onChange={(answer) => {
                              setReligion(answer.value);
                            }}
                            datas={RelligoionData}
                          />
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium">ID Card No</label>
                          <TextInput
                            value={personalInfo.id_card_no}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                id_card_no: e.target.value,
                              }))
                            }
                          />
                        </div>

                        <div>
                          <label className="block mb-1 text-md font-medium">Passport No</label>
                          <TextInput
                            value={personalInfo.passport_no}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                passport_no: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      {/* ---------------line 4----------------- */}

                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">Phone No.</label>
                          <NumberInput
                            value={personalInfo.phone_no}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                phone_no: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium">Phone No.(2)</label>
                          <NumberInput
                            value={personalInfo.phone_no_2}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                phone_no_2: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className=" col-span-2  ">
                          <label className="block mb-1 text-md font-medium">Email</label>
                          <TextInput
                            value={personalInfo.email}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                email: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      {/* ---------------line 5----------------- */}
                      <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">Current Address</label>
                          <TextInput
                            value={personalInfo.address}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                address: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium">Permanent Address</label>
                          <TextInput
                            value={personalInfo.permanent_address}
                            onChange={(e) =>
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                permanent_address: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      {/* ---------------line 7----------------- */}
                      <div className="grid grid-cols-4 md:grid-cols-4 gap-4">
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Contact Name</label>
                          <TextInput
                            value={emergencyContact.emergency_contact_name}
                            onChange={(e) =>
                              setEmergencyContact((prev: any) => ({
                                ...prev,
                                emergency_contact_name: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Contact Email</label>
                          <TextInput
                            value={emergencyContact.emergency_contact_email}
                            onChange={(e) =>
                              setEmergencyContact((prev: any) => ({
                                ...prev,
                                emergency_contact_email: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Contact Phone No.</label>
                          <TextInput
                            value={emergencyContact.emergency_contact_phone_no}
                            onChange={(e) =>
                              setEmergencyContact((prev: any) => ({
                                ...prev,
                                emergency_contact_phone_no: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Family (Dependent) </label>
                          <NumberInput
                            value={emergencyContact.family_dependent}
                            onChange={(e) =>
                              setEmergencyContact((prev: any) => ({
                                ...prev,
                                family_dependent: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </CollapsibleContent>
                </Collapsible>
                <Collapsible open={isOpens} onOpenChange={setIsOpens} className="w-full outline-none focus:border-none ">
                  <div className="flex items-center justify-between">
                    <h4 className="text-xl font-semibold text-blue-600  ">Integration System</h4>
                    <CollapsibleTrigger asChild>
                      <Button variant="ghost" size="sm">
                        <ChevronDown className={cn("h-4 w-4 transition-transform duration-300", !isOpens && "rotate-180")} />
                        <span className="sr-only">Toggle</span>
                      </Button>
                    </CollapsibleTrigger>
                  </div>

                  <CollapsibleContent className="space-y-2">
                    <div className="space-y-6 px-2 py-4 duration-900">
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">Telegram Account ID</label>
                          <TextInput
                            value={personalInfo.employee_telegram_id}
                            onChange={(event) => {
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                employee_telegram_id: event.target.value,
                              }));
                            }}
                          />
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium"> FlipFlop Account ID</label>

                          <div className="flex justify-between items-center border border-gray-200 rounded-md pe-2 ">
                            <div className="gap-3 flex items-center  rounded-md   w-[180px] ">
                              <ImageUrl
                                src={!ShopEmployeeDetail?.user?.picture ? noneProfile : ShopEmployeeDetail?.user?.picture}
                                className=" h-[40px] w-[40px] rounded-tl-md rounded-bl-md"
                                alt={ShopEmployeeDetail?.user?.picture}
                              />
                              <div className="flex flex-col text-start ">
                                <div className="flex items-center space-x-2 max-w-full">
                                  <p className="text-sm font-medium line-clamp-1 overflow-hidden">{ShopEmployeeDetail?.user?.name}</p>
                                  {ShopEmployeeDetail?.user?.is_verified === "Yes" && <img src={profileVerified} alt="" className="w-[15px] h-[15px]" />}
                                </div>
                                <span className="text-sm text-muted-foreground line-clamp-1">{ShopEmployeeDetail?.user?.account_id}</span>
                              </div>
                            </div>
                            {ShopEmployeeDetail?.user ? (
                              <UserRoundX
                                onClick={() => {
                                  setShopEmployeeDetail((prevItemGroups: any) => {
                                    return {
                                      ...prevItemGroups,
                                      employee_account_id: "",
                                      user: "",
                                    };
                                  });
                                }}
                                className=" cursor-pointer text-muted-foreground "
                              />
                            ) : (
                              <UserRoundPlus
                                onClick={() => {
                                  setIsOpenDialogAddUser(true);
                                  getShopPermissionSearchUser("");
                                }}
                                className=" cursor-pointer text-muted-foreground "
                              />
                            )}
                          </div>
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium">NSSF ID No.</label>
                          <TextInput
                            value={jobInfo.nssf_no}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                nssf_no: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium">Attendance ID</label>
                          <TextInput
                            value={jobInfo.attendance_card_no}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                attendance_card_no: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space-y-6 px-2 duration-900">
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">Payment Method</label>

                          <InputSelectAutoSuggest
                            value={paymenthod}
                            onChange={(answer) => {
                              setPaymethod(answer.value);
                            }}
                            datas={Paymenthod}
                          />
                        </div>
                        <div>
                          <label className="block mb-1 text-md font-medium"> Bank Account No.</label>
                          <TextInput
                            value={personalInfo.bank_account_no}
                            onChange={(event) => {
                              setPersonalInfo((prev: any) => ({
                                ...prev,
                                bank_account_no: event.target.value,
                              }));
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </CollapsibleContent>
                </Collapsible>
                <Collapsible open={isOpen3} onOpenChange={setIsOpen3} className="w-full outline-none focus:border-none ">
                  <div className="flex items-center justify-between">
                    <h4 className="text-xl font-semibold text-blue-600  ">Humam Resource, Compensation and Benefits</h4>
                    <CollapsibleTrigger asChild>
                      <Button variant="ghost" size="sm">
                        <ChevronDown
                          className={cn(
                            "h-4 w-4 transition-transform duration-300", // transition effect
                            !isOpen3 && "rotate-180" // rotate when open
                          )}
                        />
                        <span className="sr-only">Toggle</span>
                      </Button>
                    </CollapsibleTrigger>
                  </div>
                  <CollapsibleContent className="space-y-2">
                    <div className="space-y-6 px-2 py-4 ">
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div>
                          <label className="block mb-1 text-md font-medium">Card No.</label>
                          <TextInput
                            value={jobInfo.card_no}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                card_no: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="col-span-3 ">
                          <label className="block mb-1 text-md font-medium">Position</label>
                          <TextInput
                            value={jobInfo.position}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                position: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                      <div className="mt-4 bg-gray-100 dark:bg-[#1e293b]   px-2 py-3 rounded-md">
                        <label className="block mb-1 text-md font-medium">Department</label>
                        <div className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-3 gap-2">
                          {department?.map((item: any, index: any) => {
                            return (
                              <button
                                onClick={() => {
                                  // toggleDepartmentSelection(item.description);
                                  setDepartmentName(item.description);
                                  setDepartmentActive(item.description);
                                  setDepartmentSelect(true);
                                }}
                                className={`border px-4 py-1.5 rounded-lg text-sm font-semibold ${
                                  departmentActive === item.description ? "bg-primary text-white border-transparent" : "dark:bg-transparent border border-gray-300 "
                                } `}
                              >
                                <p className="text-md font-semibold line-clamp-2 overflow-hidden">{item.description}</p>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                      {/* {departmentSelect === false ? <label className="text-red-600 text-sm">{departmentMessage}</label> : ""} */}
                      {/* Joined DateProbation Date */}
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div className="">
                          <label className="block mb-1 text-md font-medium">
                            Joined Date <span className="text-red-600">*</span>
                          </label>

                          <div className="">
                            <DatePicker
                              className="py-4 h-[45px] border border-gray-300 "
                              onChange={(value) => {
                                setJoinedDate(value);
                              }}
                              value={joinedDate}
                            />
                          </div>
                          {!joinedDate ? <label className="text-red-600 text-sm">{joinedDateMessage}</label> : ""}
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">
                            Probation Date <span className="text-red-600">*</span>
                          </label>

                          <div className="">
                            <DatePicker
                              className="py-4 h-[45px] border border-gray-300 "
                              onChange={(value) => {
                                setProbationDate(value);
                              }}
                              value={probationDate}
                            />
                          </div>
                          {!probationDate ? <label className="text-red-600 text-sm">{probationDateMessage}</label> : ""}
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Last Working Date </label>

                          <DatePickerInput
                            placeholder=""
                            className="py-4 h-[45px] border border-gray-300 "
                            onChange={(value) => {
                              setLastWorkingDate(value);
                            }}
                            value={lastWorkingDate === "2500-01-01" || lastWorkingDate === "1900-01-01" || !lastWorkingDate ? "" : lastWorkingDate}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Basic Salary </label>
                          <NumberInput
                            className="min-h-[45px]"
                            value={jobInfo.basic_salary}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                basic_salary: e.target.value,
                              }))
                            }
                          />
                          {/* {jobInfo.basic_salary === "" ? <label className="text-red-600 text-sm">{salary}</label> : ""} */}
                        </div>

                        <div className="">
                          <label className="block mb-1 text-md font-medium">Meal/Food </label>
                          <TextInput
                            className="min-h-[45px]"
                            value={jobInfo.food_allownace}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                food_allownace: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Phone </label>
                          <TextInput
                            className="min-h-[45px]"
                            value={jobInfo.phone_allownace}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                phone_allownace: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="">
                          <label className="block mb-1 text-md font-medium">Housing </label>
                          <TextInput
                            className="min-h-[45px]"
                            value={jobInfo.housing_allownace}
                            onChange={(e) =>
                              setJobInfo((prev: any) => ({
                                ...prev,
                                housing_allownace: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </CollapsibleContent>
                </Collapsible>

                {/* Working Hour */}
                <Shift shiftGroupId={shiftGroupId} setShiftGroupId={setShiftGroupId} userShopShiftGroup={userShopShiftGroup} setUserShopShiftGroup={setUserShopShiftGroup} />
                {/* Line Manager */}

                {editEmloyeeId && (
                  <>
                    <div className="flex items-center justify-between mt-2 ">
                      <Collapsible open={isOpen4} onOpenChange={setIsOpen4} className="w-full outline-none focus:border-none ">
                        <div className="flex items-center justify-between">
                          <h4 className="text-xl font-semibold mb-3 mt-4 text-blue-600  ">Direct Line Manager</h4>
                          <CollapsibleTrigger asChild>
                            <Button variant="ghost" size="sm">
                              <ChevronDown
                                className={cn(
                                  "h-4 w-4 transition-transform duration-300", // transition effect
                                  !isOpen4 && "rotate-180" // rotate when open
                                )}
                              />
                              <span className="sr-only">Toggle</span>
                            </Button>
                          </CollapsibleTrigger>
                        </div>

                        <CollapsibleContent className=" rounded-md m-0 p-0">
                          <div className="space-y-6 py-1 ">
                            <div className={`grid md:grid-cols-3 ${window.innerWidth <= 1500 ? "lg:grid-cols-5" : "lg:grid-cols-5"}  gap-y-3 gap-x-2 mb-10  `}>
                              {ShopEmployeeDetail?.managers?.map((item: any, index: number) => {
                                return (
                                  <div key={index} className={`relative z-1 w-full max-w-sm border rounded-lg cursor-pointer `}>
                                    <div className=" w-full relative overflow-hidden aspect-square ">
                                      {/* <ImageUrl className="rounded-t-md cursor-pointer object-cover h-full w-full " src={item.picture} alt="" /> */}
                                      <ImageUrl className="rounded-t-md cursor-pointer w-full h-full object-cover" src={!item.picture ? noneProfile : item.picture} alt="" />
                                    </div>

                                    <label
                                      className="absolute opacity-80 p-1 mx-auto z-50 top-2 right-2 text-white group bg-red-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                                    >
                                      {loadingSubmitDeleteShopEmployeeManager === true && idRecommendedDelete === item.employee_id ? (
                                        <Loader className="animate-spin w-8 h-8" />
                                      ) : (
                                        <Minus
                                          onClick={() => {
                                            setIdRecommendedDelete(item.employee_id);
                                            submitDeleteShopEmployeeManager(item.employee_id);
                                          }}
                                          className="w-8 h-8"
                                        />
                                      )}
                                    </label>

                                    <div className={`p-4 `}>
                                      <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.local_name}</h5>
                                      <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>

                                      <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>

                                      <p className="font-semibold line-clamp-2 text-sm  text-muted-foreground h-[20px]">
                                        {/* {item.joined_date} */}
                                        {(() => {
                                          const date = new Date(item.joined_date);
                                          const day = date.getDate();
                                          const weekday = date.toLocaleDateString("en-GB", {
                                            weekday: "short",
                                          });
                                          const month = date.toLocaleDateString("en-GB", {
                                            month: "short",
                                          });

                                          const year = date.getFullYear();
                                          return `${month}, ${day}-${weekday}-${year}`;
                                        })()}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                              <div
                                onClick={() => {
                                  setisDailogAddLineManager(true);
                                }}
                                className={`h-[300px] flex items-center justify-center w-full max-w-sm  rounded-lg cursor-pointer  border border-gray-200 bg-gray-100 dark:bg-black`}
                              >
                                <label
                                  className=" p-1 mx-auto z-50 top-2 right-2 text-white group bg-blue-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                                >
                                  <Plus className="text-sm cursor-pointer  dark:text-white" />
                                </label>
                              </div>
                            </div>
                          </div>
                        </CollapsibleContent>
                      </Collapsible>
                    </div>
                    <div className="flex items-center justify-between ">
                      <Collapsible open={isOpen4} onOpenChange={setIsOpen4} className="w-full outline-none focus:border-none ">
                        <div className="flex items-center justify-between">
                          <h4 className="text-xl font-semibold mb-3 mt-4 text-blue-600  ">permissions</h4>
                          <CollapsibleTrigger asChild>
                            <Button variant="ghost" size="sm">
                              <ChevronDown
                                className={cn(
                                  "h-4 w-4 transition-transform duration-300", // transition effect
                                  !isOpen4 && "rotate-180" // rotate when open
                                )}
                              />
                              <span className="sr-only">Toggle</span>
                            </Button>
                          </CollapsibleTrigger>
                        </div>

                        <CollapsibleContent className=" rounded-md m-0 p-0">
                          <div className=" py-1 ">
                            <table className="min-w-full border-collapse  rounded-md overflow-hidden mt-2">
                              <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                                <tr className="border-none text-[15px] text-start  ">
                                  <th className="px-4 py-3 text-start">Permission Type</th>
                                  <th className="pe-[90px] py-3 text-end">Permission</th>
                                </tr>
                              </thead>
                              <tbody>
                                {ShopEmployeeDetail?.permissions?.map((item: any, index: number) => {
                                  return (
                                    <tr
                                      key={index}
                                      className={`text-center group ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b]" : "bg-gray-200 dark:bg-[#2c3a52]"} hover:bg-gray-300`}
                                    >
                                      <td className="py-2 px-4 text-left align-top">
                                        <p className="px-3 my-1 inline-block rounded-md py-1 font-semibold text-sm line-clamp-1">{item?.permission_type}</p>
                                      </td>
                                      <td className="py-2 px-4 text-center flex items-end justify-end  align-top">
                                        <Select value={item.permission} onValueChange={(val) => handlePermissionChange(index, val)}>
                                          <SelectTrigger className="w-[150px]">
                                            <SelectValue />
                                          </SelectTrigger>
                                          <SelectContent>
                                            <SelectGroup>
                                              {["Fully Control", "Limited", "Restricted"]?.map((items: any, index: number) => (
                                                <SelectItem key={index} value={items}>
                                                  {items}
                                                </SelectItem>
                                              ))}
                                            </SelectGroup>
                                          </SelectContent>
                                        </Select>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </CollapsibleContent>
                      </Collapsible>
                    </div>
                  </>
                )}
              </div>
              <ScrollBar orientation="vertical" />
            </ScrollArea>
          )}
          <>
            <div className="flex justify-between  gap-3 pr-[20px] items-center px-4 left-0 w-full">
              {isCreateStaff !== true ? (
                <>
                  <button
                    onClick={() =>
                      showDialogConfirm({
                        titileButtonSubmit: "Yes, Delete",
                        titileButtonCancel: "No, Cancel",
                        title: "Delete",
                        message: "Do you want to delete ?",
                        onSubmit() {
                          submitDeleteShopEmployee();
                        },
                      })
                    }
                    className="w-full mt-6   bg-red-500 text-white text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
                  >
                    {loadingSubmitDelete ? <Loader className="animate-spin" /> : "Delete"}
                  </button>
                  <button
                    onClick={() => {
                      onSubmitCreateAndUpdateStaff();
                    }}
                    className="w-full mt-6 flex items-center justify-center  bg-blue-500 text-white text-lg py-2 rounded-lg"
                  >
                    {loadingSubmitCreateUpdateStaff ? <Loader className="animate-spin" /> : "Save"}
                  </button>
                </>
              ) : (
                <button
                  onClick={() => {
                    if (personalInfo.local_name === "") {
                      setStaffName("Staff name is required *");
                    }

                    if (!dob) {
                      setDobMessage("Date of Birth is required *");
                    }

                    if (!joinedDate) {
                      setjoinedDateMessage("Jonine date is required *");
                    }
                    if (!probationDate) {
                      setprobationDateMessage("Probation Date is required *");
                      return;
                    } else {
                      onSubmitCreateAndUpdateStaff();
                    }
                  }}
                  className="w-full mt-6 flex items-center justify-center  bg-blue-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
                >
                  {loadingSubmitCreateUpdateStaff ? <Loader className="animate-spin" /> : "Save"}
                </button>
              )}
            </div>
          </>
        </div>
      </div>
      <DailogAdddLineManagerStaff
        onUploadSuccess={(res) => {
          if (res.status === "success") {
            getShopEmployeeManager();
          }
        }}
        setSearchTextInput={setSearchTextInput}
        itemEmployeeManager={itemEmployeeManager}
        setItemEmployeeManager={setItemEmployeeManager}
        setShopEmployeeDetail={setShopEmployeeDetail}
        ShopEmployeeDetail={ShopEmployeeDetail}
        editEmloyeeId={editEmloyeeId}
        setShiftGroupId={setShiftGroupId}
        isDailogAddLineManager={isDailogAddLineManager}
        setisDailogAddLineManager={setisDailogAddLineManager}
      />
      <DailogAddUserAccountId
        loadingGetUser={loadingGetUser}
        ShopEmployeeDetail={ShopEmployeeDetail}
        setItemShopPermissionSearchUser={setItemShopPermissionSearchUser}
        itemShopPermissionSearchUser={itemShopPermissionSearchUser}
        getShopPermissionSearchUser={getShopPermissionSearchUser}
        onUploadSuccess={({ res }) => {
          setPersonalInfo((prev: any) => ({
            ...prev,
            employee_account_id: res.account_id,
          }));
          setShopEmployeeDetail((prevItemGroups: any) => {
            return {
              ...prevItemGroups,
              employee_account_id: res.account_id,
              user: res,
            };
          });
        }}
        isOpenDialogAddUser={isOpenDialogAddUser}
        setIsOpenDialogAddUser={setIsOpenDialogAddUser}
      />
    </>
  );
}
